import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { CompanyList } from "../utils/types/companyList";

export const fetchCompanyListData = async () => {
  const response = await axiosServices.get("/company");
  const resData = await response.data
  return convertToCamelCase<CompanyList[]>(resData.data);
};

export const updateCompanyData = async (
  id: string,
  data: {
    [key: string]: any;
    companyId: string;
  }
) => {
  const inputData = convertToSnakeCase(data);
   await axiosServices.put(`/company/${id}`, inputData);
  return {
    success: true,
    data
  }
};

export const deleteCompanyData = async (id: string) => {
  const response = await axiosServices.delete(`/company/${id}`);
  return { success: response.data.success, id };
};

export const addCompanyData = async (
  data: {
    [key: string]: any;
  }
) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.post(`/company`, inputData);
  return convertToCamelCase<CompanyList>(response.data.data);
};